import { render, staticRenderFns } from "./PlatformColors.vue?vue&type=template&id=73a97715&scoped=true"
import script from "./PlatformColors.vue?vue&type=script&lang=js"
export * from "./PlatformColors.vue?vue&type=script&lang=js"
import style0 from "./PlatformColors.vue?vue&type=style&index=0&id=73a97715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a97715",
  null
  
)

export default component.exports